import * as colors from '@cimpress/react-components/lib/colors';
import Icon from '@cimpress/react-components/lib/Icon';
import { css } from 'react-emotion';
import PropTypes from 'prop-types';
import React from 'react';

const titleSpacerStyle = css({
  flexBasis: 0,
  flexGrow: 1
});

class StepTitle extends React.Component {
  static defaultProps = {
    titleStyle: 'warning'
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    description: PropTypes.string,
    additionalInfo: PropTypes.object,
    titleStyle: PropTypes.oneOf(['success', 'warning', 'danger'])
  };

  render() {
    const { title, description, additionalInfo, icon, titleStyle } = this.props;

    return (
      <div className={`flex-container ${titleStyle}`}>
        <div className="row1">
          <aside className="icon" style={icon ? { paddingRight: '50px' } : {}}>
            {icon && (
              <Icon
                color={
                  titleStyle === 'success'
                    ? colors.success.base
                    : titleStyle === 'warning'
                      ? colors.persimmon.base
                      : colors.danger.base
                }
                name={icon}
                size="4x"
              />
            )}
          </aside>
          <div className="middle">
            <div className={`title  `}>
              <h3 style={{ fontWeight: 300, fontSize: '24px' }}>{title}</h3>
            </div>
            <div className="description">
              <p>{description}</p>
            </div>
          </div>
          <aside className={`spacer ${titleSpacerStyle}`} />
        </div>
        {additionalInfo ? (
          <div className="row2">
            <div className="middle">{additionalInfo}</div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default StepTitle;
